/** Shallow compare identity editor drafts (string fields plus extra_social_order). */
export function shallowDraftEqual(
  a: Record<string, unknown>,
  b: Record<string, unknown>,
): boolean {
  const keys = new Set([...Object.keys(a), ...Object.keys(b)])
  for (const key of keys) {
    if (!draftFieldEqual(a[key], b[key])) return false
  }
  return true
}

function draftFieldEqual(left: unknown, right: unknown): boolean {
  if (Array.isArray(left) || Array.isArray(right)) {
    return JSON.stringify(left ?? []) === JSON.stringify(right ?? [])
  }
  return String(left ?? '') === String(right ?? '')
}
